module.exports = __webpack_public_path__ + "img/female5.23b0c565.jpeg";